<template>
    <div class="col-6">
        <button class="btn form-control" @click="toggleActive" :class="classes">{{ this.text }}</button>
    </div>
</template>

<script>
    export default {
        props: ['isActive','text'],

        computed: {
            classes() {

                return [
                    this.isActive ? 'btn-primary btn-step-4' : 'btn-outline-secondary btn-step-4-secondary'
                ]
            },
        },

        data() {
            return {

            };
        },

        methods: {
            toggleActive() {
                this.$emit('onToggle')
            }
        }
    }
</script>
